module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0141.jpg?v=2a0b7d78";